import * as api from '@owl-nest/api-client/latest'
import * as reward from './reward'
import * as variant from './variant'

export type Sku<PROJECT_EXTRA_FIELDS extends string = ''> =
  | {
      type: 'reward'
      item: reward.Reward<PROJECT_EXTRA_FIELDS>
      quantity: number
    }
  | {
      type: 'variant'
      item: variant.Variant
      quantity: number
    }

function isReward(item: api.Reward | api.Variant): item is api.Reward {
  return !('parent' in item)
}

export function Sku<PROJECT_EXTRA_FIELDS extends string = ''>(
  orderItem: api.OrderItem,
  project: api.Project<PROJECT_EXTRA_FIELDS>,
): Sku<PROJECT_EXTRA_FIELDS> | undefined {
  const item = orderItem.reward
  if (isReward(item)) {
    return {
      type: 'reward',
      item: reward.Reward(item, project),
      quantity: orderItem.quantity,
    }
  }
  if (item.parent !== undefined) {
    return {
      type: 'variant',
      item: variant.Variant(item, reward.Reward(item.parent, project) as reward.Reward<''>),
      quantity: orderItem.quantity,
    }
  }
}

export function getReward<PROJECT_EXTRA_FIELDS extends string = ''>(
  sku: Sku<PROJECT_EXTRA_FIELDS>,
): reward.Reward<PROJECT_EXTRA_FIELDS> {
  return sku.type === 'reward' ? sku.item : (sku.item.parent as reward.Reward<PROJECT_EXTRA_FIELDS>)
}

export function isLegacy(sku: Sku<any>): boolean {
  return reward.isLegacy(getReward(sku))
}

export function title(sku: Sku<any>): string | undefined {
  return reward.title(getReward(sku))
}
